module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-footer"
  }, [_c('div', {
    staticClass: "nav-footer"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('')
    }
  }, [_vm._v("หน้าแรก")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('about')
    }
  }, [_vm._v("เกี่ยวกับ กสศ.")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('fund')
    }
  }, [_vm._v("ทุนสร้างโอกาส")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('our-work')
    }
  }, [_vm._v("นวัตกรรมต้นแบบ")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('success-case')
    }
  }, [_vm._v("บอกเล่าความสำเร็จ")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('knowledge')
    }
  }, [_vm._v("คลังสมอง")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('contact')
    }
  }, [_vm._v("ติดต่อเรา")])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "logo-footer",
    attrs: {
      "src": require("../assets/domain-custom/base/logo-domain.png"),
      "srcset": ((require('../assets/domain-custom/base/logo-domain.png')) + " 1x, " + (require('../assets/domain-custom/base/logo-domain@2x.png')) + " 2x"),
      "alt": "LOGO TCFE"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._v("\n        กองทุนเพื่อความเสมอภาคทางการศึกษา (กสศ.)"), _c('br'), _vm._v("\n        อาคารเอส. พี. (อาคารเอ) ชั้น 13 เลขที่ 388"), _c('br'), _vm._v("\n        ถนนพหลโยธิน แขวงสามเสนใน เขตพญาไท กรุงเทพมหานคร 10400"), _c('br'), _vm._v("\n        โทรศัพท์ : 02-079-5475, โทรสาร: 02-619-1812"), _c('br'), _vm._v("\n        www.eef.or.th\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    staticClass: "ic_facebook",
    attrs: {
      "href": "https://www.facebook.com/EEFthailand/",
      "target": "_blank"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('a', {
    staticClass: "ic_youtube",
    attrs: {
      "href": "https://www.youtube.com/user/QLFthailand/",
      "target": "_blank"
    }
  }, [_vm._v("Youtube")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6353180b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6353180b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteFooter.vue
// module id = 737
// module chunks = 1